import React, { useCallback, useContext, useEffect, useState } from 'react';
import Header from '../components/Header';
import { Link, useNavigate } from 'react-router-dom';
import { findAllCarts, removeCartProduct } from '../service/ProductsService';
import Loading from '../components/LoadingError/Loading';
import { ResponsiveContext } from '../contexts/ResponsiveContext';
import { createPreorder } from '../service/OrdersService';
import Message from '../components/LoadingError/Error';
import { adminColors } from '../constants/constantsValues';

const CartScreen = ({ user }) => {
  const [cartItems, setCartItems] = useState([]);
  // const [size, setSize] = useState();
  // const [color, setColor] = useState();
  // const [qty, setQty] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();

  const navigate = useNavigate();

  const { is450, is775, is1200 } = useContext(ResponsiveContext);

  const total = cartItems.reduce((a, i) => a + i.qty * i.price, 0).toFixed(2);

  const refreshCartItems = useCallback(() => {
    findAllCarts()
      .then((carts) => {
        setCartItems(carts);
        setLoading(false);
      })
      .catch((error) => setError(error.response.data.message));
  }, []);

  useEffect(() => {
    if (error) {
      setLoading(false);
    }
  }, [error]);

  useEffect(() => {
    refreshCartItems();
  }, []);

  const checkOutHandler = () => {
    if (user) {
      const finalCartItems = [];

      cartItems.map((item) => {
        const filterParams = {};
        filterParams.name = item.name;
        filterParams.qty = item.qty;
        filterParams.color = item.color;
        filterParams.size = item.size;
        filterParams.image = item.image;
        filterParams.price = item.price;
        filterParams.productId = item.productId;

        finalCartItems.push(filterParams);
      });

      createPreorder(finalCartItems)
        .then((preorderId) => navigate(`/preorder/${preorderId}`))
        .catch((error) => setError(error.response.data.message));
    }
  };

  const removeFromCartHandle = (product) => {
    removeCartProduct(product)
      .then(() => refreshCartItems())
      .catch((error) => setError(error.response.data.message));
  };

  // TODO
  // Update cart

  return (
    <>
      <Header searcherDisabled={true} shopLink={true} />
      {/* Cart */}
      <div className='container'>
        {error && <Message variant='alert-danger'>{error}</Message>}
        {loading ? (
          <div className='container'>
            <Loading />
          </div>
        ) : (
          <>
            {cartItems?.length === 0 ? (
              <div className=' alert alert-info text-center mt-3'>
                Tu carrito está vacío
                <Link
                  className='btn btn-success mx-5 px-5 py-3'
                  to='/shop'
                  style={{
                    fontSize: '12px',
                  }}
                >
                  COMPRAR AHORA
                </Link>
              </div>
            ) : (
              <>
                <div className=' alert alert-info text-center mt-3'>
                  Todos los productos del carrito
                  <Link className='text-success mx-2' to='/cart'>
                    ({cartItems?.length})
                  </Link>
                </div>
                {/* cartiterm */}
                {cartItems?.map((item) => (
                  <div className='cart-iterm row' key={item.productId}>
                    <div
                      onClick={() =>
                        removeFromCartHandle({
                          productId: item.productId,
                          color: item.color,
                          size: item.size,
                        })
                      }
                      className='remove-button d-flex justify-content-center align-items-center'
                    >
                      <i className='fas fa-times'></i>
                    </div>
                    <div className='cart-image col-md-3'>
                      <img src={item.image} alt={item.name} />
                    </div>
                    <div className='cart-text my-3 col-md-3 d-flex align-items-center'>
                      <Link to={`/products/${item.productId}`}>
                        <h4>{item.name}</h4>
                      </Link>
                    </div>
                    <div className='cart-qty mt-3 mt-md-0 col-md-6 col-lg-6 d-flex flex-row justify-content-between align-items-center'>
                      {/* <div className='cart-qty d-flex flex-row justify-content-center align-items-center'> */}
                      <div className='d-flex justify-content-center'>
                        {!450 && <h5 className='me-1'>T: </h5>}
                        {is450 && !is775 && <h5 className='me-1'>Talla: </h5>}
                        {is775 && !is1200 && <h5 className='me-1'>T: </h5>}
                        {is1200 && <h5 className='me-1'>Talla: </h5>}
                        <h5>{item.size}</h5>
                      </div>
                      <div className='d-flex justify-content-center'>
                        {!450 && <h5 className='me-1'>C: </h5>}
                        {is450 && !is775 && <h5 className='me-1'>Color: </h5>}
                        {is775 && !is1200 && <h5 className='me-1'>C: </h5>}
                        {is1200 && <h5 className='me-1'>Color: </h5>}
                        {item.color && (
                          <div
                            className='mx-1 d-flex align-items-center'
                            style={{
                              width: '25px',
                              height: '25px',
                              backgroundColor: `${
                                adminColors.filter(
                                  (el) => el.name === item.color
                                )[0]?.color
                              }`,
                              border: '1px solid black',
                              borderRadius: '50%',
                              cursor: 'pointer',
                            }}
                            key={item.color}
                          ></div>
                        )}
                      </div>
                      <div className='d-flex justify-content-center'>
                        <h5 className=''> {item.qty} Uds </h5>
                      </div>

                      <div className='d-flex justify-content-center'>
                        <h4 className='fs-5'>
                          {item?.price.toString().replace('.', ',')}
                          {item?.price
                            .toString()
                            .replace('.', ',')
                            .split(',')[1]
                            ? item?.price
                                .toString()
                                .replace('.', ',')
                                .split(',')[1].length === 1
                              ? '0'
                              : ''
                            : ',00'}{' '}
                          €
                        </h4>
                      </div>

                      {/* </div> */}
                      {/* <div className='cart-qty d-flex flex-row justify-content-center align-items-center'>
                        {!450 && <h5 className='me-1'>C: </h5>}
                        {is450 && !is775 && <h5 className='me-1'>Color: </h5>}
                        {is775 && !is1200 && <h5 className='me-1'>C: </h5>}
                        {is1200 && <h5 className='me-1'>Color: </h5>}
                        {item.color && (
                          <div
                            className='mx-1 d-flex align-items-center'
                            style={{
                              width: '25px',
                              height: '25px',
                              backgroundColor: `${item.color}`,
                              border: '1px solid black',
                              borderRadius: '50%',
                              cursor: 'pointer',
                            }}
                            key={item.color}
                          ></div>
                        )}
                      </div> */}
                      {/* <div className='cart-qty d-flex flex-row justify-content-center align-items-center'>
                        <h5 className=''> {item.qty} Uds </h5> */}

                      {/* <select
                          value={item.qty}
                          onChange={
                            (e) => handleCart(e)
                            // dispatch(addToCart(item.product, Number(e.target.value)))
                          }
                        >
                          {[...Array(item.countInStock).keys()].map((x) => (
                            <option key={x + 1} value={x + 1}>
                              {x + 1}
                            </option>
                          ))}
                        </select> */}
                      {/* </div> */}
                    </div>

                    {/* <div className='cart-price mt-3 mt-md-0 col-md-2 align-items-sm-end align-items-start  d-flex flex-column justify-content-center col-sm-7'>
                      <h6>PRICE</h6>
                      <h4>
                        {item?.price * item.qty.toString().replace('.', ',')}
                        {item?.price *
                        item.qty.toString().replace('.', ',').split(',')[1]
                          ? item?.price *
                              item.qty
                                .toString()
                                .replace('.', ',')
                                .split(',')[1].length ===
                            1
                            ? '0'
                            : ''
                          : ',00'}{' '}
                        €
                      </h4>
                    </div> */}
                  </div>
                ))}

                {/* End of cart iterms */}
                <div className='total'>
                  <span className='sub'>Total:</span>
                  <span className='total-price'>
                    {total?.replace('.', ',')} €
                  </span>
                </div>
                <hr />
                <div className='cart-buttons d-flex align-items-center row'>
                  <Link to='/shop' className='col-md-6 '>
                    <button>Continuar comprando</button>
                  </Link>
                  {total > 0 && (
                    <div className='col-md-6 d-flex justify-content-md-end mt-3 mt-md-0'>
                      <button onClick={checkOutHandler}>
                        Procesar el pedido
                      </button>
                    </div>
                  )}
                </div>
              </>
            )}{' '}
          </>
        )}
      </div>
    </>
  );
};

export default CartScreen;
